document.addEventListener("DOMContentLoaded", () => {

  const selector =
    document.getElementById("curvatureType");

  if (!selector) return;

  selector.addEventListener("change", () => {

  const active =
    document.querySelector(
      ".embroidery-text-layer.active-layer"
    );

  if (!active) return;

  active.dataset.curve =
    selector.value;

  applyCurvature(
    active,
    parseInt(selector.value)
  );

  if(window.EMBStorage){
    window.EMBStorage.save();
  }

});

});

function applyCurvature(layer, mode) {

  const textContent =
    layer.querySelector(".text-content");

  if (!textContent) return;

  const letters =
    textContent.querySelectorAll(".curve-letter");

  if (!letters.length) return;

  const count = letters.length;

  const radius =
Math.max(
80,
count * 12
);
const curveCenterX =
layer.offsetWidth / 2;

const curveCenterY =
layer.offsetHeight / 2;
const left =
parseFloat(layer.style.left) || 0;

const top =
parseFloat(layer.style.top) || 0;

const width =
layer.offsetWidth;

const height =
layer.offsetHeight;
console.log(
"CURVE SIZE",
{
width,
height
}
);

const centerX =
left + (width / 2);

const centerY =
top + (height / 2);

layer.dataset.centerX = centerX;
layer.dataset.centerY = centerY;
layer.dataset.curve = mode;
layer.dataset.radius = radius;

  const spacing = 20;

  // STRAIGHT
  if (mode === 0) {

  letters.forEach((letter,index)=>{

    letter.style.left =
      `${20 + (index * 28)}px`;

    letter.style.top =
      `40px`;

    letter.style.transform =
      `translate(-50%, -50%)`;

  });

  return;
}

  // ARCH
  if (mode === 1) {

    letters.forEach((letter, index) => {

      const angle =
        (-((count - 1) * 10) / 2) +
        (index * 10);

      const radians =
        angle * Math.PI / 180;

      const x =
        Math.sin(radians) * radius;

      const y =
        Math.cos(radians) * radius;

      letter.style.left =
`${curveCenterX + x}px`;

letter.style.top =
`${curveCenterY - y}px`;

      letter.style.transform =
        `translate(-50%, -50%) rotate(${angle}deg)`;

    });

  }

  // REVERSE ARCH
  if (mode === 2) {

    letters.forEach((letter, index) => {

      const angle =
        (-((count - 1) * 10) / 2) +
        (index * 10);

      const radians =
        angle * Math.PI / 180;

      const x =
        Math.sin(radians) * radius;

      const y =
        Math.cos(radians) * radius;

      letter.style.left =
`${curveCenterX + x}px`;

letter.style.top =
`${curveCenterY + y}px`;

      letter.style.transform =
        `translate(-50%, -50%) rotate(${-angle}deg)`;

    });

  }

  // FULL CIRCLE
  if (mode === 3) {

    letters.forEach((letter, index) => {

      const angle =
        (360 / count) * index;

      const radians =
        angle * Math.PI / 180;

      const x =
        Math.cos(radians) * radius;

      const y =
        Math.sin(radians) * radius;

      letter.style.left =
`${curveCenterX + x}px`;

letter.style.top =
`${curveCenterY + y}px`;

      letter.style.transform =
        `translate(-50%, -50%) rotate(${angle + 90}deg)`;

    });

  }

}